__webpack_require__.p = "/reports-legacy-abilities-cleanup/referrals-hub/";